export default __webpack_public_path__ + "static/media/icon_cancel.1e49693d.svg";